import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionStoreRepository } from '../repositories/session.repository';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
    const authToken = inject(SessionStoreRepository).accessToken;
    const authorizedReq = req.clone({
        headers: req.headers.set("Authorization", `Bearer ${authToken}`)
    });
    
    return next(authorizedReq);
}